import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Owner } from "./owner.model";
import { Role } from "./role.model";
import { GlobalsService } from "../../globals.service";

@Injectable({ providedIn: "root" })
export class OwnerService {
  public dataSource: MatTableDataSource<Owner>;
  public ownerList: Owner[];
  public roleList: Role[];
  public selectedOwner: Owner;

  public constructor(
    private http: HttpClient,
    public globalsService: GlobalsService,
  ) {
    this.selectedOwner = new Owner();
  }

  public deleteOwner(id: number): Promise<Owner> {
    return this.http.delete<Owner>(`owner/${id}`).toPromise();
  }

  public getOwner(id: number) {
    return this.http.get<Owner>(`owner/${id}`).toPromise();
  }

  public getOwnerList(): Promise<Owner[]> {
    var loggedInOwnerID = this.globalsService.getOwnerID();
    return this.http.get<Owner[]>(`owner/list/${loggedInOwnerID}`).toPromise();
  }

  public getRoleList(): Promise<Role[]> {
    return this.http.get<Role[]>(`role/list`).toPromise();
  }

  public postOwner(owner: Owner): Promise<Owner> {
    owner.id = 0;
    const body = JSON.stringify(owner);
    return this.http.post<Owner>(`owner`, body).toPromise();
  }

  public putOwner(owner: Owner): Promise<Owner> {
    const body = JSON.stringify(owner);
    return this.http.put<Owner>(`owner`, body).toPromise();
  }

  public refresh() {
    this.getOwnerList().then((x) => {
      this.dataSource.data = x;
    });
  }
}
